// Импорты SVG иконок категорий как компонентов
import type { Component } from 'vue'
import AvtoMotoAksessuaryIcon from '~/assets/svg/category-icons/avto_moto_aksessuary.svg?component'
import DetskieTovaryIcon from '~/assets/svg/category-icons/detskie_tovary.svg?component'
import InstrumentySpetstehnikaIRemontIcon from '~/assets/svg/category-icons/instrumenty_spetstehnika_i_remont.svg?component'
import OdezhdaObuvIKostyumyIcon from '~/assets/svg/category-icons/odezhda_obuv_i_kostyumy.svg?component'
import RaznoeIcon from '~/assets/svg/category-icons/raznoe.svg?component'
import RobotyIcon from '~/assets/svg/category-icons/roboty.svg?component'
import SportTurizmIAktivyyOtdyhIcon from '~/assets/svg/category-icons/sport_turizm_i_aktivyy_otdyh.svg?component'
import TehnikaIElektronikaIcon from '~/assets/svg/category-icons/tehnika_i_elektronika.svg?component'
import TovaryDlyaVzroslyhIcon from '~/assets/svg/category-icons/tovary-dlya-vzroslyh.svg?component'
import TovaryDlyaDomaISadaIcon from '~/assets/svg/category-icons/tovary_dlya_doma_i_sada.svg?component'
import UslugiIcon from '~/assets/svg/category-icons/uslugi.svg?component'
import VodnyyTransportIcon from '~/assets/svg/category-icons/vodnyy-transport.svg?component'
import VozdushnyTransportIcon from '~/assets/svg/category-icons/vozdushny-transport.svg?component'
import ZdorovieIcon from '~/assets/svg/category-icons/zdorovie.svg?component'

// Маппинг slug категорий к их иконкам-компонентам
const categoryIcons: Record<string, Component> = {
  'avto_moto_aksessuary': AvtoMotoAksessuaryIcon,
  'detskie_tovary': DetskieTovaryIcon,
  'instrumenty_spetstehnika_i_remont': InstrumentySpetstehnikaIRemontIcon,
  'odezhda_obuv_i_kostyumy': OdezhdaObuvIKostyumyIcon,
  'raznoe': RaznoeIcon,
  'roboty': RobotyIcon,
  'sport_turizm_i_aktivyy_otdyh': SportTurizmIAktivyyOtdyhIcon,
  'tehnika_i_elektronika': TehnikaIElektronikaIcon,
  'tovary_dlya_doma_i_sada': TovaryDlyaDomaISadaIcon,
  'tovary-dlya-vzroslyh': TovaryDlyaVzroslyhIcon,
  'zdorovie': ZdorovieIcon,
  'vodnyy-transport': VodnyyTransportIcon,
  'uslugi': UslugiIcon,
  'vozdushny-transport': VozdushnyTransportIcon,
}

// Функции для работы с иконками категорий
function getCategoryIcon (slug: string) {
  return categoryIcons[slug] || null
}

function hasCategoryIcon (slug: string) {
  return slug in categoryIcons
}

export const useCategorisTreeItem = () => {
  return {
    getCategoryIcon,
    hasCategoryIcon,
  }
}
